export default __webpack_public_path__ + "static/media/loginLandscape.23338b96.svg";